import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { isOcpsPolicyEnabled, NotificationsPolicySettingId } from "owa-owsprime-policies-store";
import isUserAllowedToChangeNotificationSettings from "../utils/isUserAllowedToChangeNotificationSettings";
import getStore from "../store/store";

const APP_DEFAULT_NOTIFICATIONS_ENABLED = true;

export default function getPolicyAwareNotificationsEnabled(): boolean {
    const policyValue = isOcpsPolicyEnabled(NotificationsPolicySettingId.GetNotifications, getGlobalSettingsAccountMailboxInfo(), APP_DEFAULT_NOTIFICATIONS_ENABLED);
    
    if (!isUserAllowedToChangeNotificationSettings()) {
        return policyValue;
    }
    
    const userValue = getStore().global?.notificationsEnabled;
    return userValue ?? policyValue;
}
